// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"196":"assets/css/app","242":"assets/css/legacy","483":"assets/css/legacy_vue","725":"assets/css/colorblind","926":"assets/css/cdash"}[chunkId] + ".css";
};